import Location from "./Location";
import classNames from "classnames";
import Stops from "./Stops";
import Icon from "@hudson/ui/components/Icon";

interface PickupDropoffParams {
  dropoff: be.Location;
  hideString?: boolean;
  horizontal?: boolean;
  pickup: be.Location;
  stops?: be.Stop[];
  shiftLeft?: boolean;
}

function PickupDropoff({
  dropoff,
  hideString,
  horizontal,
  pickup,
  stops = [],
  shiftLeft,
}: PickupDropoffParams): JSX.Element {
  return (
    <div
      className={classNames(
        "flex",
        horizontal ? "xs:flex-row gap-x-1 items-center justify-between" : "flex-col gap-y-1",
        {
          "-ml-9 -mr-6": shiftLeft,
        },
      )}
    >
      <Location
        location={pickup}
        shiftLeft={shiftLeft}
        horizontal={horizontal}
        hideString={hideString}
      />

      <Icon
        type={horizontal ? "arrowRight" : "arrowDown"}
        className={classNames(shiftLeft ? "ml-5" : horizontal ? "ml-0" : "ml-3", "w-8 h-8")}
        color="var(--primary-color-darker)"
      />

      {stops.length > 0 && (
        <Stops
          shiftLeft={shiftLeft}
          horizontal={horizontal}
          hideString={hideString}
          stops={stops}
        />
      )}

      <Location
        location={dropoff}
        shiftLeft={shiftLeft}
        flip={horizontal}
        horizontal={horizontal}
        hideString={hideString}
      />
    </div>
  );
}

export default PickupDropoff;
